import { Box, Input, Label } from "@generalapplications/ui";

/**
 * A field no person sees: out of the page and the accessibility tree, and out
 * of the tab order, but in the markup for a form-filling bot to fill. The
 * server drops any message that arrives with it filled.
 */
export function ContactHoneypot() {
  return (
    <Box hidden aria-hidden="true">
      <Label htmlFor="company">Company</Label>
      <Input
        id="company"
        name="company"
        type="text"
        tabIndex={-1}
        autoComplete="off"
      />
    </Box>
  );
}
